<div [id]="chartdiv_id" class="lineChartDiv"></div>